import apiClient from '../utils/apiClient';

/**
 * Obtiene la lista de destinos que coinciden con la búsqueda
 * 
 * @param {string} destination - Palabra o frase a buscar
 * @returns {Promise<Array< Destination >>} - La lista de destinos que coinciden con la búsqueda
 */
export const getDestinations = async (destination) => {
  try {
    const response = await apiClient.get(`/busqueda/motor?filtro=${destination}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};
/**
 * Obtiene la disponibilidad de hoteles en base a las habitaciones proporcionadas.
 * 
 * @param {Array} arrAlojamientos - Arreglo de id y tipo de destino.
 * @returns {Promise<Object>} - Un objeto con los hoteles.
 * @throws {Error} - Lanza un error si la solicitud falla.
 */
export const getHotels = async (arrAlojamientos) => {
  try {
    const response = await apiClient.post(`/hoteles`, arrAlojamientos);    
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};
/**
 * Obtiene la disponibilidad de hoteles en base a las habitaciones proporcionadas.
 * 
 * @param {Array} arrRooms - Arreglo de objetos con la información de cada habitación. Cada objeto debe tener las siguientes propiedades:
 *  - idAlojamiento: {number} - El ID del alojamiento (hotel, apartahotel, etc.).
 *  - idHabitacion: {number} - El ID de la habitación.
 *  - tipoHabitacion: {string} - El tipo de habitación (Individual, Doble, Triple, etc.).
 *  - cantidadHabitaciones: {number} - La cantidad de habitaciones a reservar.
 * @returns {Promise<Object>} - Un objeto con la disponibilidad de cada habitación.
 * @throws {Error} - Lanza un error si la solicitud falla.
 */
export const getHotelAvailability = async (arrRooms) => {
  try {
    const response = await apiClient.post(`/hoteles/disponibilidad`, arrRooms);    
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};


/**
 * Retrieves available filters for hotel searches.
 *
 * @returns {Promise<Object>} - An object containing various filters for hotels.
 * @throws {Error} - Throws an error if the request fails.
 */

export const getHotelFilters = async (idDestino) => {
  try {
    const response = await apiClient.get(`/hoteles/filtros/${idDestino}`);
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};



export const getHotelesRate = async (arrRates) => {
  try {
    const response = await apiClient.post(`/hoteles/rate`, arrRates);    
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};